import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { Button } from '@/components/ui/button';
import { PlayCircleIcon } from '@heroicons/react/24/outline';
const HomeHeroOS = () => {
  const {
    openModal
  } = useEarlyAdopter();
  const handlePrimaryCTA = () => {
    openModal('Homepage Hero - Start My Free Trial');
  };
  const handleSecondaryCTA = () => {
    // Scroll to a demo section or open video modal
    document.getElementById('daily-pulse')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section className="relative w-full min-h-[85vh] lg:min-h-[90vh] overflow-hidden">
      {/* Full-width background image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url(/lovable-uploads/bonkers_image_an_older_woman-2.webp)'
    }} />
      
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent" />
      
      {/* Content positioned on the left side with readable backdrop */}
      <div className="relative h-full min-h-[85vh] lg:min-h-[90vh] flex items-center">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl pt-24 md:pt-32 pb-20 md:pb-28">
            {/* Semi-transparent backdrop for text readability */}
            <div className="bg-black/50 backdrop-blur-sm rounded-2xl p-8 md:p-10 text-left">
              {/* Main headline */}
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 tracking-tight leading-[1.1] drop-shadow-lg">
                Thrive at Home with Confidence.
              </h1>
              
              {/* Subheadline */}
              <p className="text-xl sm:text-2xl lg:text-3xl text-white/90 font-semibold mb-6 drop-shadow-md">
                The Home's Operating System for Your Independence.
              </p>
              
              {/* Supporting copy */}
              <p className="text-base sm:text-lg md:text-xl text-white/85 mb-8 leading-relaxed max-w-xl drop-shadow-sm">
                SeniorThrive is a private layer of support that keeps your home and wellness 
                in sync with your needs. It steadies your daily rhythm and strengthens your 
                environment—so independence feels natural, confident, and connected.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4 mb-4">
                <Button onClick={handlePrimaryCTA} size="lg" className="text-lg px-8 py-6 rounded-xl font-semibold bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl">
                  Request Early Access
                </Button>
                
                <Button onClick={handleSecondaryCTA} variant="outline" size="lg" className="text-lg px-8 py-6 rounded-xl font-semibold gap-2 bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 hover:text-white">
                  <PlayCircleIcon className="w-5 h-5" />
                  See How It Works
                </Button>
              </div>

              {/* Early access helper text */}
              <p className="text-sm text-white/80 mb-2">
                SeniorThrive is currently in early access. New members are invited in stages.
              </p>
              <p className="text-xs text-white/60">
                Private. Secure. Always on your terms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HomeHeroOS;